import React from 'react';
import { categoryInfo } from '../data/quizData';

interface HomeProps {
  onStart: () => void;
}

export const Home: React.FC<HomeProps> = ({ onStart }) => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="max-w-4xl w-full">
        <div className="text-center mb-8 animate-fade-in">
          <div className="text-6xl mb-4">🛡️</div>
          <h1 className="text-5xl font-bold bg-gradient-to-r from-primary-700 to-accent-700 bg-clip-text text-transparent mb-4">
            Arnaqu'Quiz
          </h1>
          <p className="text-xl mb-2 font-medium" style={{ color: 'var(--wcag-text)' }}>
            Testez vos connaissances et apprenez à détecter les arnaques
          </p>
          <p style={{ color: 'var(--wcag-text-muted)' }}>
            Un quiz interactif pour vous protéger au quotidien
          </p>
        </div>

        <div className="card animate-slide-up mb-8">
          <h2 className="text-2xl font-bold mb-4" style={{ color: 'var(--wcag-text)' }}>
            📋 Thèmes abordés
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {Object.entries(categoryInfo).map(([key, info]) => (
              <div
                key={key}
                className="p-4 rounded-lg bg-gradient-to-br from-primary-50 to-accent-50 dark:from-primary-950 dark:to-accent-950 border-2 border-primary-200 dark:border-primary-800 hover:shadow-lg hover:border-primary-300 dark:hover:border-primary-700 transition-all"
              >
                <div className="flex items-center gap-3">
                  <span className="text-3xl">{info.icon}</span>
                  <div>
                    <h3 className="font-semibold" style={{ color: 'var(--wcag-text)' }}>
                      {info.name}
                    </h3>
                    <p className="text-sm" style={{ color: 'var(--wcag-text)' }}>
                      {info.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="card animate-slide-up bg-gradient-to-br from-primary-50 to-accent-50 dark:from-primary-950 dark:to-accent-950 border-2 border-primary-300 dark:border-primary-700">
          <h2 className="text-xl font-bold mb-3" style={{ color: 'var(--wcag-text)' }}>
            ℹ️ Comment ça marche ?
          </h2>
          <ul className="space-y-2 mb-6" style={{ color: 'var(--wcag-text)' }}>
            <li className="flex items-start gap-2">
              <span className="font-bold" style={{ color: 'var(--wcag-primary)' }}>
                ✓
              </span>
              <span>Répondez à une série de questions sur différents types d'arnaques</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold" style={{ color: 'var(--wcag-primary)' }}>
                ✓
              </span>
              <span>Découvrez les bonnes pratiques après chaque question</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="font-bold" style={{ color: 'var(--wcag-primary)' }}>
                ✓
              </span>
              <span>Obtenez votre score et des conseils personnalisés</span>
            </li>
          </ul>

          <button onClick={onStart} className="btn-primary w-full text-lg py-4">
            🚀 Commencer le quiz
          </button>
        </div>

        <div className="mt-6 text-center text-sm" style={{ color: 'var(--wcag-text-muted)' }}>
          <p>💡 Astuce : Prenez votre temps et lisez bien chaque question</p>
        </div>
      </div>
    </div>
  );
};
